var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { LogFactory } from './modules/config/logging';
import { RTCConnectionHandler } from './modules/RTC/RTCConnectionHandler';
import { RTCStats } from './modules/RTC/RTCStats';
import DTMFManager from './modules/DTMF/DTMFManager';
import Analytics from './modules/config/analytics';
import CallEvents from './JiveCallEvents';
import ConfigsManager from './modules/config/configs';
import { Browser, getBrowserName, resumeAudioContext } from './helpers';
import { Timer } from './JiveSessionUtils';
import { devicesEqual, buildAudioConstraints } from './devices/devices.utils';
import { DeviceActions } from './devices/devices.actions';
import { inputFallBack } from './devices/devices.epics';
import RTCRejectAction from './modules/RTC/RTCRejectAction';
var TrackKind;
(function (TrackKind) {
    TrackKind["AUDIO"] = "audio";
    TrackKind["VIDEO"] = "video";
})(TrackKind || (TrackKind = {}));
var Logger = LogFactory('Call');
/**
 * Class representing a call. The constructor is called internally within JiveRTC when "dial" is called from the client.
 */
var Call = /** @class */ (function (_super) {
    __extends(Call, _super);
    /**
     * Create an Outgoing Call.
     * @param {Object} channel - The WebSocket connection to use for sending events.
     * @param {integer} id - The ID of the session to be sent in the connection. Needs to be an odd and unique integer.
     * @param {string} callee - The callee's uri, name or extension.
     * @param {Object} mediaConstraints - The configuration of the local media.
     */
    function Call(_channel, _audioContext, _callee, _map, store, _streamQualityUpdatesRequested) {
        if (_streamQualityUpdatesRequested === void 0) { _streamQualityUpdatesRequested = false; }
        var _this = _super.call(this) || this;
        _this._channel = _channel;
        _this._audioContext = _audioContext;
        _this._callee = _callee;
        _this._map = _map;
        _this.store = store;
        _this._streamQualityUpdatesRequested = _streamQualityUpdatesRequested;
        _this._id = null;
        _this._sipCallId = null;
        _this._rtcHandler = null;
        _this._rtcStats = null;
        _this._streamQualitySubscription = null;
        _this._remoteStream = null;
        _this._streamQuality = 100;
        _this._dtmfManager = null;
        _this._initialOffer = true;
        _this._selectedInputDevice = null;
        _this._options = { offerToReceiveAudio: true, offerToReceiveVideo: false };
        _this._deviceActions = new DeviceActions();
        _this._unsubscribe = null;
        _this._closeReason = null;
        _this._fallback = null;
        resumeAudioContext(_this._audioContext);
        _this._dtmfDestination = _this._audioContext.createMediaStreamDestination();
        _this.on(_this.RINGING, function () { return _this._stopDTMF(); });
        _this.on(_this.CONNECTED, function () { return _this._stopDTMF(); });
        return _this;
    }
    Call.prototype.mixStreamIntoOutgoingAudio = function (streamToMix) {
        return __awaiter(this, void 0, void 0, function () {
            var hasNonAudioTrack;
            return __generator(this, function (_a) {
                if (!this.id) {
                    throw this.CALL_UNINITIALIZED;
                }
                if (!this._rtcHandler) {
                    throw this.PEER_CONNECTION_UNINITIALIZED;
                }
                hasNonAudioTrack = streamToMix
                    .getTracks()
                    .some(function (_a) {
                    var kind = _a.kind;
                    return kind !== TrackKind.AUDIO;
                });
                if (hasNonAudioTrack) {
                    throw this.MIXING_AUDIO_STREAM_NOT_SUPPORTED;
                }
                try {
                    this._rtcHandler.mixStreamIntoOutgoingAudio(streamToMix, this._audioContext);
                }
                catch (error) {
                    Logger.error('Mix streams error', error);
                    throw this.MEDIA_MIXING_ERROR;
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Method to end the call. "Hangup" can be called at any moment during the call.
     * @example
     * //Media will be terminated and hangup signaling sent.
     * call.hangup()
     */
    Call.prototype.hangup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.id) {
                            this.close(this.CALL_HANGUP, true);
                            throw this.CALL_UNINITIALIZED;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._channel.send('hangup', { callId: this.id })
                            // Analytics.trackEvent('Call', 'Hangup', 'SUCCESS')
                        ];
                    case 2:
                        _a.sent();
                        // Analytics.trackEvent('Call', 'Hangup', 'SUCCESS')
                        Logger.log('Hangup success');
                        this.close(this.CALL_HANGUP, true);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        // Analytics.trackEvent('Call', 'Hangup', error.errorCode)
                        Logger.error('Hangup failure', error_1);
                        this.close(this.CALL_HANGUP, true);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Method to put the call on hold. "Hold" can only be called when the call is either ongoing or
     * when the call was already put on hold by the remote peer.
     * @example
     * // Media will stop locally and the remote party will hear the "waiting room" music.
     * call.hold()
     */
    Call.prototype.hold = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.id) {
                            throw this.CALL_UNINITIALIZED;
                        }
                        if (!this._rtcHandler) {
                            throw this.PEER_CONNECTION_UNINITIALIZED;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        // Issue with gateway requires mute
                        this._rtcHandler.mute();
                        return [4 /*yield*/, this._channel.send('hold', { callId: this.id })];
                    case 2:
                        _a.sent();
                        Logger.log('Hold successful');
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        if (error_2.errorCode === 'NOT_FOUND') {
                            Logger.warn('Hold failed - call has already ended');
                        }
                        else {
                            Logger.error('Hold failure', error_2);
                        }
                        if (this._rtcHandler) {
                            this._rtcHandler.unmute();
                        }
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Method to resume the call. "Resume" can only be called when the call is on hold.
     * @example
     * //Media will resume locally and the remote party will hear your steam again.
     * call.resume()
     */
    Call.prototype.resume = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.id) {
                            throw this.CALL_UNINITIALIZED;
                        }
                        if (!this._rtcHandler) {
                            throw this.PEER_CONNECTION_UNINITIALIZED;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this._rtcHandler.unmute();
                        return [4 /*yield*/, this._channel.send('unhold', { callId: this.id })
                            // Analytics.trackEvent('Call', 'Resume', 'SUCCESS')
                        ];
                    case 2:
                        _a.sent();
                        // Analytics.trackEvent('Call', 'Resume', 'SUCCESS')
                        Logger.log('Resume successful');
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        // Analytics.trackEvent('Call', 'Resume', error.errorCode)
                        if (error_3.errorCode === 'NOT_FOUND') {
                            Logger.warn('Resume failed - call has already ended');
                        }
                        else {
                            Logger.error('Resume failure', error_3);
                        }
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Method to mute the call. "Mute" can can be called at any moment during the call.
     * @example
     * //Incoming media will stop locally. No sound will be incoming in the stream.
     * call.mute()
     */
    Call.prototype.mute = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.id) {
                            throw this.CALL_UNINITIALIZED;
                        }
                        if (!this._rtcHandler) {
                            throw this.PEER_CONNECTION_UNINITIALIZED;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        this._rtcHandler.mute();
                        if (!!this.isPlayingMixedStreams) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._channel.send('mute', { callId: this.id })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_4 = _a.sent();
                        Logger.error('Mute failure', error_4);
                        throw error_4;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Method to unmute the call. "Unmute" can only be called when the call is muted.
     * @example
     * //Incoming media will be unmuted locally. Sound will be coming again in the stream.
     * call.unmute()
     */
    Call.prototype.unmute = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.id) {
                            throw this.CALL_UNINITIALIZED;
                        }
                        if (!this._rtcHandler) {
                            throw this.PEER_CONNECTION_UNINITIALIZED;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this._rtcHandler.unmute();
                        return [4 /*yield*/, this._channel.send('unmute', { callId: this.id })
                            // Analytics.trackEvent('Call', 'Unmute', 'SUCCESS')
                        ];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        // Analytics.trackEvent('Call', 'Unmute', error.errorCode)
                        Logger.error('Unmute failure', error_5);
                        throw error_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Call.prototype._changeInputSource = function () {
        return __awaiter(this, void 0, void 0, function () {
            var devices, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._rtcHandler) {
                            throw this.PEER_CONNECTION_UNINITIALIZED;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        this.store.dispatch(this._deviceActions.setInputReady(false));
                        devices = this.store.getState().ioDevices;
                        return [4 /*yield*/, this._rtcHandler.getMedia(buildAudioConstraints(devices), this._audioContext)];
                    case 2:
                        _a.sent();
                        if (!(getBrowserName() !== Browser.FIREFOX)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.renegotiate(false)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.store.dispatch(this._deviceActions.setInputReady(true));
                        return [3 /*break*/, 6];
                    case 5:
                        error_6 = _a.sent();
                        Logger.error('_changeInputSource error', error_6);
                        this.store.dispatch(this._deviceActions.setInputReady(true));
                        // Analytics.trackEvent('Call', 'Input', error.errorCode)
                        throw error_6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Method to transfer the call.
     * @param {string|Object} callee - The string of the callee for a blind transfer and a second Call Object for a warm transfer.
     * @example
     * call.transfer('1234567890')
     * @example
     * call.transfer(call2)
     */
    Call.prototype.transfer = function (callee) {
        return __awaiter(this, void 0, void 0, function () {
            var warmData, error_7, data, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.id) {
                            throw this.CALL_UNINITIALIZED;
                        }
                        if (!(typeof callee !== 'string')) return [3 /*break*/, 5];
                        warmData = {
                            callId: this.id,
                            referId: callee.id
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._channel.send('warm', warmData)];
                    case 2:
                        _a.sent();
                        this.close(this.TRANSFER_SUCCESS, true);
                        return [3 /*break*/, 4];
                    case 3:
                        error_7 = _a.sent();
                        // Analytics.trackEvent('Call', 'Warm', error.errorCode)
                        Logger.error('Warm transfer failure', error_7);
                        throw error_7;
                    case 4: return [2 /*return*/];
                    case 5:
                        data = {
                            callId: this.id,
                            dialString: callee
                        };
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, this._channel.send('blind', data)];
                    case 7:
                        _a.sent();
                        this.close(this.TRANSFER_SUCCESS, true);
                        return [3 /*break*/, 9];
                    case 8:
                        error_8 = _a.sent();
                        // Analytics.trackEvent('Call', 'Blind', error.errorCode)
                        Logger.error('Blind transfer failure', error_8);
                        throw error_8;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    Call.prototype.merge = function (callee) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.id) {
                            throw this.CALL_UNINITIALIZED;
                        }
                        if (!callee.id) return [3 /*break*/, 4];
                        data = {
                            callId: this.id,
                            referId: callee.id
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._channel.send('merge', data)];
                    case 2:
                        _a.sent();
                        Logger.log('Merge successful with', callee);
                        return [3 /*break*/, 4];
                    case 3:
                        error_9 = _a.sent();
                        // Analytics.trackEvent('Call', 'Merge', error.errorCode)
                        Logger.error('Merge failure', error_9);
                        throw error_9;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Split merged three-way call.
     */
    Call.prototype.split = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.id) {
                            throw this.CALL_UNINITIALIZED;
                        }
                        data = {
                            callId: this.id
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._channel.send('split', data)];
                    case 2:
                        _a.sent();
                        Logger.log('Split merged call successful');
                        return [3 /*break*/, 4];
                    case 3:
                        error_10 = _a.sent();
                        Logger.error('Split call failure', error_10);
                        throw error_10;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Method to send a Dual Tone Multi Frequency signaling.
     * @param {string} tones - The string to send via dtmf.
     * @example
     * call.dtmf('1')
     */
    Call.prototype.dtmf = function (tones) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.id) {
                            throw this.CALL_UNINITIALIZED;
                        }
                        data = {
                            callId: this.id,
                            digits: tones
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._channel.send('dtmf', data)];
                    case 2:
                        _a.sent();
                        Logger.log('DTMF successful', tones);
                        resumeAudioContext(this._audioContext);
                        if (!this._dtmfManager) {
                            this._dtmfManager = new DTMFManager(this._audioContext, this._dtmfDestination);
                        }
                        this._dtmfManager.insertDTMF(tones);
                        return [3 /*break*/, 4];
                    case 3:
                        error_11 = _a.sent();
                        Logger.error('DTMF failure', error_11);
                        throw error_11;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Call.prototype._stopDTMF = function () {
        if (this._dtmfManager) {
            this._dtmfManager.stopDTMF();
        }
    };
    Call.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var deviceState, sdp, error_12, error_13;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        deviceState = this.store.getState().ioDevices;
                        if (deviceState && deviceState.selectedInputDevice) {
                            this._selectedInputDevice = deviceState.selectedInputDevice;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 8, , 9]);
                        this._options.iceRestart = false;
                        if (!this._rtcHandler) {
                            this._rtcHandler = new RTCConnectionHandler();
                            this._rtcHandler.onTrack = function (track) { return _this._rtcHandlerTrack(track); };
                            this._rtcHandler.onNegotiationNeeded = function () { return _this._onNegotiationNeeded(); };
                        }
                        this._unsubscribe = this.store.subscribe(function () { return _this.selectInputDevice(); });
                        if (this._streamQualityUpdatesRequested) {
                            this._subscribeStreamQualityUpdates();
                        }
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 6, , 7]);
                        return [4 /*yield*/, this._rtcHandler.getMedia(buildAudioConstraints(deviceState))];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this._rtcHandler.createOffer(this._options)];
                    case 4:
                        sdp = _a.sent();
                        return [4 /*yield*/, this._sendOffer(sdp)];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        error_12 = _a.sent();
                        // If an error occurs while handling the offer, check to see if it is because
                        // the call ended during one of the many async operations we have to do. If so,
                        // just throw a CALL_CANCELLED exception.
                        if (this._closeReason) {
                            Logger.warn('Call: Call ended before call initialization could complete');
                            throw this.CALL_CANCELLED;
                        }
                        throw error_12;
                    case 7:
                        this._map.set(this.id || '', this);
                        this.emit(this.CONNECTING);
                        Analytics.trackEvent('Call', 'Initiate', 'SUCCESS');
                        return [3 /*break*/, 9];
                    case 8:
                        error_13 = _a.sent();
                        if (error_13.errorCode === 'CONFLICT') {
                            // if webrtc gateway returns 409 error it should be logged without terminating the call
                            Analytics.trackEvent('Call', 'Initiate', error_13.errorCode);
                            Logger.log('409 error event', error_13);
                            this._map.set(this.id || '', this);
                            Analytics.trackEvent('Call', 'Initiate', 'SUCCESS');
                        }
                        else if (error_13.errorCode === this.CALL_CANCELLED.errorCode) {
                            throw error_13;
                        }
                        else {
                            Analytics.trackEvent('Call', 'Initiate', error_13.errorCode);
                            Logger.error('Call:init error', error_13);
                            this.close(error_13);
                            throw error_13;
                        }
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    Call.prototype.dial = function (fallback) {
        if (fallback === void 0) { fallback = null; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._fallback = fallback;
                return [2 /*return*/, this.init()];
            });
        });
    };
    Call.prototype._sendOffer = function (sdp) {
        return __awaiter(this, void 0, void 0, function () {
            var data, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._rtcHandler) {
                            throw this.PEER_CONNECTION_UNINITIALIZED;
                        }
                        if (!this._initialOffer) {
                            // Existing call
                            return [2 /*return*/, this._rtcHandler.setRemoteAnswer(this._rtcHandler.remoteSdp || '')];
                        }
                        this._initialOffer = false;
                        data = {
                            'dialString': this._callee,
                            'offer': this._rtcHandler.sdp || '',
                            'fallback': this._fallback ? this._fallback : undefined
                        };
                        return [4 /*yield*/, this._channel.send('call', data)];
                    case 1:
                        response = _a.sent();
                        this.id = response.callId;
                        if (response.sipCallId) {
                            this.sipCallId = response.sipCallId;
                        }
                        return [4 /*yield*/, this._rtcHandler.setRemoteAnswer(response.sdp)];
                    case 2:
                        _a.sent();
                        this.store.dispatch(this._deviceActions.setInputReady(true));
                        return [2 /*return*/];
                }
            });
        });
    };
    Call.prototype._rtcHandlerTrack = function (track) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this._remoteStream = track.streams[0];
                Timer.create(function () { return _this.emit(_this.TRACK, _this._remoteStream); }, 0);
                return [2 /*return*/];
            });
        });
    };
    Call.prototype.selectInputDevice = function () {
        return __awaiter(this, void 0, void 0, function () {
            var state, error_14, nextDevice;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.store) return [3 /*break*/, 7];
                        state = this.store.getState();
                        if (!state.ioDevices) return [3 /*break*/, 7];
                        if (!!devicesEqual(state.ioDevices.selectedInputDevice, this._selectedInputDevice)) return [3 /*break*/, 7];
                        this._selectedInputDevice = state.ioDevices.selectedInputDevice;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 7]);
                        return [4 /*yield*/, this._changeInputSource()];
                    case 2:
                        _a.sent();
                        Logger.log('Input device source fallback successful!');
                        return [3 /*break*/, 7];
                    case 3:
                        error_14 = _a.sent();
                        if (!(error_14.errorCode === 'MEDIA_ERROR' && state.ioDevices.selectedInputDevice)) return [3 /*break*/, 5];
                        Logger.warn('selectInputDevice: _changeInputSource failed - selecting fallback device');
                        return [4 /*yield*/, inputFallBack(state.ioDevices.selectedInputDevice, state.ioDevices.availableInputDevices, state.ioDevices.selectedInputDeviceHistory).toPromise()];
                    case 4:
                        nextDevice = _a.sent();
                        this.store.dispatch(this._deviceActions.setAudioInput(nextDevice));
                        return [3 /*break*/, 6];
                    case 5:
                        Logger.error('Input device source fallback unsuccessful.', error_14);
                        this.close(error_14);
                        _a.label = 6;
                    case 6: return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    Call.prototype.renegotiate = function (iceRestart) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.id) {
                            throw this.CALL_UNINITIALIZED;
                        }
                        if (!this._rtcHandler) {
                            throw this.PEER_CONNECTION_UNINITIALIZED;
                        }
                        this._options.iceRestart = iceRestart;
                        return [4 /*yield*/, this._rtcHandler.createOffer(this._options)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._channel.send('reOffer', { callId: this.id || '', offer: this._rtcHandler.sdp || '' })];
                    case 2:
                        response = _a.sent();
                        Logger.log('Renegotiate answer', response);
                        if (response.sdp) {
                            return [2 /*return*/, this._rtcHandler.setRemoteAnswer(response.sdp)];
                        }
                        else {
                            return [2 /*return*/, this._rtcHandler.setRemoteAnswer(this._rtcHandler.remoteSdp || '')];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Call.prototype.callEnded = function (endedEvent) {
        // This is called from the Session object if it receives an 'ended' event
        // from the gateway.
        Logger.log("Call ended with reason " + JSON.stringify(endedEvent));
        // Distinguish between an incoming call ending because the caller hung up
        // or because the call was answered elsewhere.
        var reason;
        if (endedEvent.reasonCode === 'CANCELLED') {
            if (endedEvent.reason === 'Call completed elsewhere') {
                reason = this.CALL_COMPLETED_ELSEWHERE;
            }
            else {
                reason = this.CALL_CANCELLED;
            }
        }
        else {
            reason = {
                errorCode: endedEvent.reasonCode,
                message: endedEvent.reason
            };
        }
        this.close(reason, true);
    };
    Call.prototype.close = function (reason, terminated) {
        if (terminated === void 0) { terminated = false; }
        // If the call was already closed then just return.
        if (this.id === null && this._closeReason !== null) {
            return;
        }
        // Keep track of the reason why the call was closed
        this._closeReason = reason;
        if (this._unsubscribe) {
            this._unsubscribe();
        }
        if (!terminated) {
            this.hangup();
        }
        if (this._map.has(this.id || '')) {
            this._map.delete(this.id || '');
        }
        this.id = null;
        this.sipCallId = null;
        if (this._streamQualitySubscription) {
            Logger.log('Unsubscribe from stream quality subscription');
            this._streamQualitySubscription.unsubscribe();
            this._streamQualitySubscription = null;
        }
        if (this._rtcHandler) {
            this._rtcHandler.close();
            delete this._rtcHandler;
        }
        if (this._dtmfManager) {
            this._dtmfManager.close();
            this._dtmfManager = null;
        }
        this._dtmfDestination.disconnect();
        Logger.log('Close', reason.errorCode);
        // Analytics.trackEvent('Call', 'Close', reason.errorCode)
        this.emit(this.DISCONNECTED, reason);
        this.removeAllListeners(this.CONNECTED);
        this.removeAllListeners(this.CONNECTING);
        this.removeAllListeners(this.DISCONNECTED);
        this.removeAllListeners(this.RINGING);
        this.removeAllListeners(this.TRACK);
        this.removeAllListeners(this.NO_MEDIA_RECEIVED);
        this.removeAllListeners(this.CALLEE_TALKING);
        this.removeAllListeners(this.CALLEE_STOPPED_TALKING);
        this.removeAllListeners(this.STREAM_QUALITY);
        this.removeAllListeners(this.UPDATE);
    };
    Object.defineProperty(Call.prototype, "callee", {
        get: function () {
            return this._callee;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "remoteStream", {
        get: function () {
            return this._remoteStream;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "dtmfStream", {
        get: function () {
            return this._dtmfDestination.stream;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "inputStream", {
        get: function () {
            if (this._rtcHandler) {
                return this._rtcHandler.stream;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (id) {
            this._id = id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "sipCallId", {
        get: function () {
            return this._sipCallId;
        },
        set: function (sipCallId) {
            this._sipCallId = sipCallId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "closeReason", {
        get: function () {
            return this._closeReason;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "streamQuality", {
        get: function () {
            return this._streamQuality;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "isPlayingMixedStreams", {
        get: function () {
            if (this._rtcHandler) {
                return !!this._rtcHandler.mixedStream;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "streamQualityUpdatesRequested", {
        set: function (isRequested) {
            this._streamQualityUpdatesRequested = isRequested;
            if (!this._streamQualityUpdatesRequested && this._streamQualitySubscription) {
                this._streamQualitySubscription.unsubscribe();
                this._streamQualitySubscription = null;
                return;
            }
            this._subscribeStreamQualityUpdates();
        },
        enumerable: true,
        configurable: true
    });
    Call.prototype._subscribeStreamQualityUpdates = function () {
        var _this = this;
        if (this._streamQualitySubscription) {
            return;
        }
        if (!this._rtcStats && this._rtcHandler) {
            this._rtcStats = new RTCStats(ConfigsManager.STATS_CHECK_INTERVAL, this._rtcHandler.getStats.bind(this._rtcHandler));
            this._streamQualitySubscription = this._rtcStats.qualityStats
                .subscribe(function (quality) {
                _this._streamQuality = quality;
                _this.emit(_this.STREAM_QUALITY, _this._streamQuality);
            });
        }
    };
    Call.prototype._onNegotiationNeeded = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Logger.log('Negotiation needed');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        if (this._initialOffer) {
                            Logger.log('Ignoring initial onNegotiationNeeded event');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.renegotiate(true)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        Logger.error('Renegotiation error', err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return Call;
}(CallEvents));
export { Call };
/**
 * Class representing an incoming call. The constructor is called internally within JiveRTC when
 * an incoming invite arrives in the WebSocket.
 * @extends Call
 */
var IncomingCall = /** @class */ (function (_super) {
    __extends(IncomingCall, _super);
    /**
     * Create an Incoming Call.
     * @param {Object} channel - The WebSocket connection to use for sending events.
     * @param {integer} id - The ID of the session to be sent in the connection.
     * @param {string} caller - The callee's uri, name or extension.
     */
    function IncomingCall(id, sipCallId, channel, audioContext, map, _caller, _number, store) {
        var _this = _super.call(this, channel, audioContext, _caller, map, store) || this;
        _this._caller = _caller;
        _this._number = _number;
        _this._id = id;
        _this._sipCallId = sipCallId;
        return _this;
    }
    IncomingCall.prototype.ringing = function () {
        if (!this.id) {
            throw this.CALL_UNINITIALIZED;
        }
        return this._channel.send('ringing', { callId: this.id });
    };
    IncomingCall.prototype._sendOffer = function (sdp) {
        return __awaiter(this, void 0, void 0, function () {
            var data, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.id) {
                            throw this.CALL_UNINITIALIZED;
                        }
                        if (!this._rtcHandler) {
                            throw this.PEER_CONNECTION_UNINITIALIZED;
                        }
                        Logger.log('IncomingCall: Sending answer', sdp);
                        data = {
                            callId: this.id,
                            sdp: sdp || '',
                            fallback: this._fallback ? this._fallback : undefined
                        };
                        return [4 /*yield*/, this._channel.send('answer', data)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this._rtcHandler.setRemoteAnswer(response.sdp)];
                }
            });
        });
    };
    Object.defineProperty(IncomingCall.prototype, "caller", {
        /**
         * Getter method to retrieve the caller's name.
         * @returns {string} caller's name
         * @example
         * //The caller will be returned.
         * var caller = incomingCall.caller
         */
        get: function () {
            return this._caller;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IncomingCall.prototype, "number", {
        get: function () {
            return this._number;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Method to answer the incoming call.
     * @example
     * subscribeToEvents(call)
     * createAudioElement(call.dtmfStream)
     * call.answer()
     */
    IncomingCall.prototype.answer = function (streamQualityUpdatesRequested, fallback) {
        if (streamQualityUpdatesRequested === void 0) { streamQualityUpdatesRequested = false; }
        if (fallback === void 0) { fallback = null; }
        return __awaiter(this, void 0, void 0, function () {
            var error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Logger.log('IncomingCall: answer');
                        this.streamQualityUpdatesRequested = streamQualityUpdatesRequested;
                        this._fallback = fallback;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.init()];
                    case 2:
                        _a.sent();
                        this.emit(this.CONNECTED);
                        return [3 /*break*/, 4];
                    case 3:
                        error_15 = _a.sent();
                        if (error_15.errorCode === this.CALL_CANCELLED.errorCode) {
                            // Log a specific message for this error to help us diagnose problems with answering calls.
                            if (this._closeReason) {
                                Logger.warn('IncomingCall: Answer failed because call ended before answer could complete', "Close reason: " + JSON.stringify(this._closeReason));
                                throw this._closeReason;
                            }
                        }
                        Logger.error('IncomingCall: Answer failure', error_15);
                        throw error_15;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Method to reject the incoming call.
     * @example
     * //call is rejected and hangup is sent to the network
     * call.reject()
     */
    IncomingCall.prototype.reject = function (sendToVoicemail) {
        return __awaiter(this, void 0, void 0, function () {
            var action, error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.id) {
                            throw this.CALL_UNINITIALIZED;
                        }
                        Logger.log('IncomingCall: Reject on callId', this.id);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        action = sendToVoicemail ? RTCRejectAction.SEND_TO_VOICEMAIL : RTCRejectAction.DECLINE;
                        return [4 /*yield*/, this._channel.send('reject', { callId: this.id, action: action })];
                    case 2:
                        _a.sent();
                        Analytics.trackEvent('Call', 'Reject', 'SUCCESS');
                        return [3 /*break*/, 4];
                    case 3:
                        error_16 = _a.sent();
                        Analytics.trackEvent('Call', 'Reject', error_16.errorCode);
                        Logger.error('IncomingCall: Reject failure', error_16);
                        this.close(error_16);
                        throw error_16;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return IncomingCall;
}(Call));
export { IncomingCall };
export default Call;
//# sourceMappingURL=JiveCall.js.map